// MainLayout.tsx
import { FC, useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import NavBar from "./NavBar"; // if you want the top NavBar globally visible

const { Sider, Content } = Layout;

const MainLayout: FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sider holds your Sidebar component */}
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      </Sider>

      {/* Right section holds Header (NavBar) and Content */}
      <Layout>
        <NavBar />

        <Content style={{ margin: "16px" }}>
          {/* <Outlet> is where child routes get rendered */}
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
